/**公用路径 */
export const HOST = {
    FILE_HOST: '//igyl.weizhilian.com'
}

/**数据报表出入库类型 */
export const TYPE_LIST = [
    '退货出库', '盘亏出库', '移库出库', '报损出库', '返货出库', '加工出库', '生产领料出库', '领料出库', '外销出库', '发货出库', '其它出库', '成本调整出库', '调拨出库', '菜品销售', '菜品报损',
    '调拨入库', '盘盈入库', '移库入库', '返货入库', '收货入库', '加工入库', '生产领料入库', '外销退货入库', '采购入库', '成本调整入库', '期初入库', '生产入库', '其它入库', '简单生产退料',
]
/**门店出库 */
export const MD_CHUKU_LIST = ["退货出库", "盘亏出库", "移库出库", "报损出库", "返货出库", "加工出库", "生产领料出库", "领料出库", "成本调整出库", "调拨出库", "其它出库", "菜品销售", "菜品报损"]
/**门店入库 */
export const MD_RUKU_LIST = ["调拨入库", "盘盈入库", "移库入库", "收货入库", "加工入库", "生产领料入库", "采购入库", "成本调整入库", "期初入库", "生产入库", "其它入库", "简单生产退料"]


// WEBPACK FOOTER //
// ./src/helpers/constants/common.js